<label class="label" *ngIf="label">
    {{ label }}
</label>
<div class="icon">

</div>
<span class="text">
    <ng-content></ng-content>
</span>
